export const primary = {
  50: 'hsl(196, 100%, 97.058824%)',
  100: 'hsl(200, 100%, 94.705882%)',
  150: 'hsl(198.461538, 95.121951%, 91.960784%)',
  200: 'hsl(199.2, 92.592593%, 89.411765%)',
  250: 'hsl(198.181818, 97.058824%, 86.666667%)',
  300: 'hsl(197.560976, 100%, 83.921569%)',
  350: 'hsl(197.142857, 100%, 80.784314%)',
  400: 'hsl(196.173913, 100%, 77.45098%)',
  450: 'hsl(199.636364, 100%, 67.647059%)',
  500: 'hsl(202.396313, 100%, 57.45098%)',
  550: 'hsl(206.352941, 100%, 50%)',
  600: 'hsl(217.339056, 98.312236%, 53.529412%)',
  650: 'hsl(216.6, 89.285714%, 43.921569%)',
  700: 'hsl(216.071429, 94.382022%, 34.901961%)',
  750: 'hsl(216.716418, 97.101449%, 27.058824%)',
  800: 'hsl(217.2, 100%, 19.607843%)',
  850: 'hsl(219.74026, 100%, 15.098039%)',
  900: 'hsl(222.545455, 100%, 10.784314%)',
  950: 'hsl(229.411765, 100%, 6.666667%)',
}
export const accent = {
  50: 'hsl(351.428571, 100%, 98.627451%)',
  100: 'hsl(350.769231, 100%, 97.45098%)',
  150: 'hsl(350.526316, 100%, 96.27451%)',
  200: 'hsl(350.4, 100%, 95.098039%)',
  250: 'hsl(351.666667, 100%, 92.941176%)',
  300: 'hsl(351.25, 100%, 90.588235%)',
  350: 'hsl(351.864407, 100%, 88.431373%)',
  400: 'hsl(352.394366, 100%, 86.078431%)',
  450: 'hsl(353.195876, 87.387387%, 78.235294%)',
  500: 'hsl(354.098361, 79.220779%, 69.803922%)',
  550: 'hsl(353.557047, 73.399015%, 60.196078%)',
  600: 'hsl(348.556701, 82.20339%, 46.27451%)',
  650: 'hsl(347.368421, 85.929648%, 39.019608%)',
  700: 'hsl(345.810811, 91.358025%, 31.764706%)',
  750: 'hsl(344.878049, 95.348837%, 25.294118%)',
  800: 'hsl(344.848485, 100%, 19.411765%)',
  850: 'hsl(347.368421, 100%, 14.901961%)',
  900: 'hsl(351.111111, 100%, 10.588235%)',
  950: 'hsl(354.545455, 100%, 6.470588%)',
}
export const grey = {
  50: 'hsl(0, 0%, 98.039216%)',
  100: 'hsl(0, 0%, 96.078431%)',
  150: 'hsl(0, 0%, 94.117647%)',
  200: 'hsl(0, 0%, 92.156863%)',
  250: 'hsl(200, 5.660377%, 89.607843%)',
  300: 'hsl(195, 6.060606%, 87.058824%)',
  350: 'hsl(197.142857, 8.860759%, 84.509804%)',
  400: 'hsl(200, 9.89011%, 82.156863%)',
  450: 'hsl(204, 6.25%, 68.627451%)',
  500: 'hsl(198, 4.385965%, 55.294118%)',
  550: 'hsl(198, 4.587156%, 42.745098%)',
  600: 'hsl(201.818182, 7.006369%, 30.784314%)',
  650: 'hsl(204, 7.352941%, 26.666667%)',
  700: 'hsl(204, 8.62069%, 22.745098%)',
  750: 'hsl(204, 10.416667%, 18.823529%)',
  800: 'hsl(206.666667, 11.688312%, 15.098039%)',
  850: 'hsl(205.714286, 12.727273%, 10.784314%)',
  900: 'hsl(204, 15.151515%, 6.470588%)',
  950: 'hsl(210, 28.571429%, 2.745098%)',
}
